module.exports = __webpack_public_path__ + "static/media/20.74e89166.webp";